var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center gap-1 text-sm font-semibold whitespace-nowrap"},[_c('span',{staticClass:"flex items-center justify-center w-4 h-4 bg-gray-200 rounded-sm",class:{
      'bg-green-700 text-gray-100': _vm.completed,
      'text-gray-900': !_vm.completed,
    }},[_vm._v(" "+_vm._s(_vm.step)+" ")]),_c('p',{class:{ 'line-through text-gray-400': _vm.completed }},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }